export { default } from './CaptchaContainer';



// WEBPACK FOOTER //
// ./src/components/Captcha/containers/CaptchaContainer/index.js